import {useAppMenu} from '@context/AppMenu'
import {IMenuGroup, IMenuItem} from '@services/api/menu.service'
import {useLang} from '_metronic/i18n/Metronici18n'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'

/** Used when a menu row has no icon set. */
const DEFAULT_ICON = 'bi-dot'

/**
 * The whole labor navigation: every menu group from sso `auth.features`
 * (GET /menu/ERPBOI_LABOR via @context/AppMenu).
 *
 * The groups, their pages, labels (title / title_bn), icons and order all come from the database and
 * are edited in the SSO menu editor — nothing here is a hardcoded menu. Role filtering and empty-group
 * removal happen server-side (MenuService.getAppMenu), so items are NOT re-gated here: `gated` would
 * re-check the same ACL against a second source of truth, and the two could disagree.
 */
export const SidebarMenuMain = () => {
  const lang = useLang()
  const {menu} = useAppMenu()

  /** Bangla where a translation exists, English otherwise. */
  const label = (n: IMenuItem | IMenuGroup) => (lang === 'bn' && n.titleBn ? n.titleBn : n.title)

  return (
    <>
      {menu.map((group: IMenuGroup) => {
        const items = group.children
        if (!items.length) return null

        return (
          <SidebarMenuItemWithSub
            key={group.featureId}
            id={group.code || group.featureId}
            title={label(group)}
            fontIcon={group.icon || DEFAULT_ICON}
            childUrls={items.map((item) => item.url)}
          >
            {items.map((item) => (
              <SidebarMenuItem
                key={item.featureId}
                to={item.url}
                title={label(item)}
                fontIcon={item.icon || DEFAULT_ICON}
              />
            ))}
          </SidebarMenuItemWithSub>
        )
      })}
    </>
  )
}
